import { render, staticRenderFns } from "./ShareProjectDuplicateModal.vue?vue&type=template&id=83218402&scoped=true"
import script from "./ShareProjectDuplicateModal.vue?vue&type=script&lang=js"
export * from "./ShareProjectDuplicateModal.vue?vue&type=script&lang=js"
import style0 from "./ShareProjectDuplicateModal.vue?vue&type=style&index=0&id=83218402&prod&lang=scss&scoped=true"
import style1 from "./ShareProjectDuplicateModal.vue?vue&type=style&index=1&id=83218402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83218402",
  null
  
)

export default component.exports